import React from 'react';
import { Container, Heading, Text, VStack, Button, Box } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaChevronRight, FaUserMd } from 'react-icons/fa';
import Roster from '../components/team/Roster';
import { PageHero, SectionHeading, IconMark } from '../components/premium';
import { Reveal } from '../components/motion';

const Surgeons = () => {
  // Populated as surgeons come on board. Until then the page explains the
  // partnership path rather than showing an empty roster.
  const surgeons = [];

  return (
    <Box>
      {/* Hero Section */}
      {/* Photographic hero, shared with every inner page. See
          components/premium/PageHero for why the photo is no longer
          hidden under a cyan gradient. */}
      <PageHero
        title={"Participating Surgeons"}
        subtitle={"Board-certified specialists partnering with Lake Lucien Surgery Center across 19 surgical specialties"}
        image="/facility/operating-room.jpg"
        imagePosition="center 65%"
      />

      <Container maxW="container.xl" py={{ base: 16, md: 20 }}>
        <VStack spacing={12} align="stretch">
          <SectionHeading
            as="h2"
            size="xl"
            mb={0}
            title="PARTICIPATING SURGEONS"
          />

          {surgeons.length > 0 ? (
            <Roster people={surgeons} />
          ) : (
            <Reveal
              bg="white"
              borderRadius="24px"
              boxShadow="card"
              border="1px solid"
              borderColor="rgba(14,47,58,0.06)"
              p={{ base: 10, md: 16 }}
              textAlign="center"
              maxW="820px"
              mx="auto"
              w="100%"
            >
              <VStack spacing={6}>
                <IconMark icon={FaUserMd} size="lg" />

                <Heading size="lg" color="ink.900" fontWeight="600">
                  Our surgeon roster is taking shape
                </Heading>

                <Text color="ink.600" fontSize="lg" lineHeight="1.7" maxW="2xl">
                  As Lake Lucien prepares to open, we are partnering with board-certified
                  specialists across orthopedics, interventional cardiology, pain management, spine, and more.
                  Participating surgeons will be listed here as they join.
                </Text>

                <Button
                  as={RouterLink}
                  to="/contact#physician-partnerships"
                  size="lg"
                  px={8}
                  variant="brandGradient"
                  rightIcon={<FaChevronRight />}
                  mt={2}
                >
                  Explore Physician Partnership
                </Button>
              </VStack>
            </Reveal>
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default Surgeons;
